<template>
  <div class="area-staff-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>社区-人员绑定</span>
      </div>
      <el-row :gutter="20" class="bind-row">
        <el-col :span="6">
          <el-select v-model="bindForm.areaId" placeholder="请选择社区" clearable style="width: 100%;">
            <el-option v-for="item in areaOptions" :key="item.areaId" :label="item.areaName" :value="item.areaId" />
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-select v-model="bindForm.staffId" filterable remote reserve-keyword placeholder="输入姓名/手机号/用户ID搜索"
            :remote-method="searchStaff" :loading="staffLoading" clearable style="width: 100%;"
            @change="handleStaffChange">
            <el-option v-for="item in staffOptions" :key="item.userId" :label="`${item.name}(${item.tel})`"
              :value="item.userId" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="handleBind">绑定</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span>已绑定人员</span>
      </div>
      <el-table v-loading="loading" :data="bindList" border style="width: 100%">
        <el-table-column prop="staffName" label="姓名" align="center" />
        <el-table-column prop="tel" label="手机号" align="center" />
        <el-table-column prop="areaName" label="社区" align="center" />
        <el-table-column prop="createTime" label="绑定时间" align="center" :formatter="formatDateTime" />
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="handleUnbind(scope.row)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </el-card>
  </div>
</template>

<script>
import { listAreas, saveAreaStaff, deleteAreaStaff, listAreaStaffs } from '@/api/community/areaApi'
import { queryStaffInfos } from '@/api/staff/staffApi'
import { dateFormat, timeFormat } from '@/utils/dateUtil'

export default {
  name: 'AreaStaffBind',
  data() {
    return {
      loading: false,
      staffLoading: false,
      areaOptions: [],
      staffOptions: [],
      staffMap: {},
      bindList: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      bindForm: {
        areaId: '',
        staffId: '',
        staffName: '',
        tel: ''
      }
    }
  },
  created() {
    this.loadAreas()
    this.loadData()
  },
  methods: {
    loadAreas() {
      listAreas({ page: 1, row: 100 }).then(res => {
        const data = res.data || {}
        this.areaOptions = data.areas || []
        this.fillAreaName()
      }).catch(() => {})
    },
    loadData() {
      this.loading = true
      listAreaStaffs({
        page: this.page.current,
        row: this.page.size
      }).then(res => {
        const data = res.data || {}
        this.bindList = data.staffs || []
        this.page.total = data.total || 0
        this.fillAreaName()
      }).catch(error => {
        this.$message.error(error.message || '获取绑定列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    fillAreaName() {
      if (!this.areaOptions.length || !this.bindList.length) {
        return
      }
      const areaMap = {}
      this.areaOptions.forEach(item => {
        areaMap[String(item.areaId)] = item.areaName
      })
      this.bindList.forEach(item => {
        if (!item.areaName) {
          item.areaName = areaMap[String(item.areaId)] || '-'
        }
      })
    },
    searchStaff(query) {
      if (!query) {
        this.staffOptions = []
        return
      }
      this.staffLoading = true
      const trimmed = query.trim()
      const isPhone = /^\d{11}$/.test(trimmed)
      const isUserId = /^\d+$/.test(trimmed) && trimmed.length > 11
      const params = {
        page: 1,
        row: 20
      }
      if (isPhone) {
        params.tel = trimmed
      } else if (isUserId) {
        params.staffId = trimmed
      } else {
        params.name = trimmed
      }
      queryStaffInfos(params).then(res => {
        const list = res.staffs || []
        this.staffOptions = list
        this.staffOptions.forEach(item => {
          this.staffMap[item.userId] = item
        })
      }).catch(() => {
        this.staffOptions = []
      }).finally(() => {
        this.staffLoading = false
      })
    },
    handleStaffChange(userId) {
      const staff = this.staffMap[userId]
      if (staff) {
        this.bindForm.staffName = staff.name
        this.bindForm.tel = staff.tel
      } else {
        this.bindForm.staffName = ''
        this.bindForm.tel = ''
      }
    },
    formatDateTime(row, column, cellValue) {
      if (!cellValue) {
        return '-'
      }
      return dateFormat(cellValue) + ' ' + timeFormat(cellValue)
    },
    handleBind() {
      if (!this.bindForm.areaId) {
        this.$message.warning('请选择社区')
        return
      }
      if (!this.bindForm.staffId) {
        this.$message.warning('请选择员工')
        return
      }
      saveAreaStaff(this.bindForm).then(() => {
        this.$message.success('绑定成功')
        this.bindForm = {
          areaId: '',
          staffId: '',
          staffName: '',
          tel: ''
        }
        this.staffOptions = []
        this.page.current = 1
        this.loadData()
      }).catch(error => {
        this.$message.error(error.message || '绑定失败')
      })
    },
    handleUnbind(row) {
      this.$confirm('确认解绑该人员？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAreaStaff({ relId: row.relId, staffId: row.staffId }).then(() => {
          this.$message.success('解绑成功')
          this.loadData()
        }).catch(error => {
          this.$message.error(error.message || '解绑失败')
        })
      }).catch(() => {})
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.area-staff-container {
  padding: 20px;

  .el-card {
    margin-bottom: 20px;
  }

  .bind-row {
    display: flex;
    align-items: center;
  }

  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
